/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { Carousel } from "@mantine/carousel";
import { Input, Tooltip } from "@mantine/core";
import moment from "moment";
import React, { useEffect } from "react";
import htmlParser from 'react-html-parser';
import { AiOutlineInfoCircle } from "react-icons/ai";
import {
  BsArrowRight
} from "react-icons/bs";
import { MdOutlineEmail } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import OnlyFooter from "../components/common_components/OnlyFooter";
import Navbar from "../components/layout_components/Navbar";
import Halment from "../faetures/Halment";
import Pagination from "../faetures/pagination";
import {
  allBlogsForRecent,
  allBlogsForSlider,
  getBlogsByPagination
} from "../redux/actions/frontendActions/blogActions";
function Blog() {
  const dispatch = useDispatch();
  const { currentPage } = useParams();
  const { allblogs, sliderBlogs, recentPost, parPage, blogCount } = useSelector(
    (state) => state.Blog
  );

  useEffect(() => {
    dispatch(allBlogsForSlider());
    dispatch(allBlogsForRecent());
  }, []);

  useEffect(() =>{
    dispatch(getBlogsByPagination(currentPage ? currentPage.split("-")[1] : 1));
  }, [currentPage]);


  return (
    <>
     <Halment title="Blogs" />
      <Navbar />

      <div className="megazine_wrapper-area">
        <div className="slider_area">
          <Carousel
            withIndicators
            height={350}
            slideSize="33.333333%"
            slideGap="md"
            breakpoints={[
              { maxWidth: "md", slideSize: "50%" },
              { maxWidth: "sm", slideSize: "100%", slideGap: 0 },
            ]}
            loop
            align="start"
          >
            {sliderBlogs.length > 0 ? (
              sliderBlogs.map((blog, index) => (
                <Carousel.Slide key={index}>
                  <Link to={`/blog/${blog._id}`} className="carosel_box">
                    <div className="img-area">
                      <img src={blog.image} alt="" />
                    </div>
                    <div className="text-area">
                      <h1>{blog.title}</h1>
                      <div className="date_flex">
                      <p>{moment(blog.createdAt).fromNow()}</p>
                    
                        <p>Md Asraful</p>
                      </div>
                    </div>
                  </Link>
                </Carousel.Slide>
              ))
            ) : (
              <h1 style={{color: "#fff"}}>Loading......</h1>
            )}
          </Carousel>
        </div>
      </div>

      <div className="middle_blogs_area">
        <div className="padding_container">
          <div className="middle_blog_wrapper_area_would_be_flex">
            <div className="left">
              {/* latest post  */}

              <div className="top_area">
                <h1>My Digital Magazine</h1>
              </div>

              <div className="latest-post">
                <h6>Lastest post</h6>

                <div className="lastest-post-grid">
                  {recentPost.length > 0 ? (
                    recentPost.map((blog, index) => (
                      <div className="card-post" key={index}>
                        <img src={blog.image} alt="" />
                        <h2>{blog.title}</h2>
                        <div className="date_flex">
                          <p>{blog.createdAt}</p>
                          <p>Md Asraful</p>
                        </div>
                        <p>

                        <p>{htmlParser(blog?.description.slice(0 , 300))} <br />
                        
                        <Link to={`/blog/${blog._id}`}>read more &gt;&gt; </Link>
                        </p>

                          
                        </p>
                      </div>
                    ))
                  ) : (
                    <h1>Loading...</h1>
                  )}
                </div>



                
              </div>

              <div className="unkowntable_post">
                <h6 className="border-h6">More post </h6>
                <div className="post-card-wrapper">
                  {allblogs.length > 0 ? (
                    allblogs.map((blog, index) => (
                      <div className="card" key={index}>
                        <div className="left">
                          <img src={blog.image} alt="" />
                        </div>
                        <div className="right">
                          <h2>{blog.title}</h2>

                          <div className="date_flex">
                            <p>25 june , 2022</p>
                            <p>Md Asraful</p>
                          </div>
                          <p>{htmlParser(blog?.description.slice(0 , 100))} <br />
                        
                        <Link to={`/blog/${blog._id}`}>read more &gt;&gt; </Link>
                        </p>
                        </div>
                      </div>
                    ))
                  ) : (
                    <h1>Loading....</h1>
                  )}
                </div>

                <div className="pagination-area">
            <Pagination
              pageNumber={currentPage ? currentPage.split("-")[1] : 1}
              perPage={parPage}
              itemCount={blogCount}
              path="/blogs"
            />
            </div>

              </div>
            </div>



            
            <div className="right">
              <div className="top-area">
                <div className="blog-deatils-title">popular blog</div>
              </div>

              <div className="popular-blog-area">
                {sliderBlogs.length > 0 ? (
                  sliderBlogs.slice(2, 4).map((blog, index) => (
                    <Link to={`/blog/${blog._id}`} className="card" key={ index}>
                      <h2>{blog.title}</h2>
                      <div className="date_flex">
                        <p>{blog.createdAt}</p>
                        <p>Md Asraful</p>
                      </div>
                    </Link>
                  ))
                ) : (
                  <h3>Loading...</h3>
                )}
              </div>

              <div className="newsletter">
                <div className="newsletter-card">
                  <h4 className="news-h4">Subscribe to Newsletter</h4>
                  <p>
                    Enter your email address below to subscribe to my newsletter
                  </p>

                  <div className="submit-area">
                    <div className="form-letter">
                      <Input
                        icon={<MdOutlineEmail />}
                        placeholder="Your email address"
                        rightSection={
                          <Tooltip
                            label="Your gmail is safe"
                            position="top-end"
                            withArrow
                          >
                            <div>
                              <AiOutlineInfoCircle
                                size={18}
                                style={{ display: "block", opacity: 0.5 }}
                              />
                            </div>
                          </Tooltip>
                        }
                      />
                    </div>
                    <div className="btn-letter">
                      <button>
                        Subscribe
                        <BsArrowRight />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>


            
          </div>
        </div>
      </div>

      <OnlyFooter/>
    </>
  );
}

export default Blog;
